import { gql } from '@apollo/client';

export const genericFields = `
  id
  area {
    value
    units
  }
  isLeased
  floor
  floors
  city {
    id
    name
  }
  location {
    id
    name
    fullName
  }
  hasMortgage
  mortgageTerms {
    monthlyPayment
    interestRate
    remainingYears
    remainingMonths
  }
  price {
    total
    currency
    perAre
  }
  company {
    id
    name
    targetType
  }
  isPaidDaily
  rooms
  hasBillOfSale
  hasRepair
  isVipped
  isFeatured
  updatedAt
  path
  photosCount
`;

export const profileItemStatusCounts = `
  PUBLISHED: items(state: PUBLISHED) {
    totalCount
  }

  VALIDATED_AND_AWAITING_PAYMENT: items(
    state: VALIDATED_AND_AWAITING_PAYMENT
  ) {
    totalCount
  }

  EXPIRED: items(state: EXPIRED) {
    totalCount
  }

  PENDING: items(state: PENDING) {
    totalCount
  }

  REJECTED: items(state: REJECTED) {
    totalCount
  }
`;

export const MAP_MARKERS_FRAGMENT = gql`
  fragment MapMarkersFields on MapMarkers {
    zoom
    bounds {
      topLeft {
        latitude
        longitude
      }
      bottomRight {
        latitude
        longitude
      }
    }
    markers {
      __typename
      ... on ClusterMapMarker {
        id
        count
        lat
        lng
      }
      ... on ItemMapMarker {
        itemId
        lat
        lng
        price
        isLeased
        isPaidDaily
      }
    }
  }
`;
